<template lang="pug">

    .ui.four.cards
        thumbnail(
            v-for="fileModel in fileModels"
            v-bind:key="fileModel.id"
            v-bind:actions="actions"
            v-bind:file-model="fileModel"
            v-bind:hide-details="hideDetails"
            v-bind:can-be-form-proof="canBeFormProof"
            v-bind:can-be-printing-data="canBePrintingData"
            v-bind:product-file-model="getProductFileModel(fileModel)"
            v-bind:product-model="productModel"
        )

</template>

<!--suppress JSUnusedGlobalSymbols -->
<script>
    import * as R from 'ramda'
    import Thumbnail from './Thumbnail'

    export default {

        components: { Thumbnail },

        computed: {

            canBeFormProof() {
                if (!this.isAnyFinalPrintingData) {
                    return false
                }

                if (this.productModel.status !== 'OFFER_CONFIRMED') {
                    return false
                }

                if (this.productModel.printingDataStatus === 'FORM_PROOF_CONFIRMED') {
                    return false
                }

                return this.$auth.isZmuekish || this.$auth.activeRoleId === 'SUPPLIER'
            },

            canBePrintingData() {
                const printingDataStatus = this.productModel.printingDataStatus
                return ['WAITING_FOR_DATA', 'IN_REVIEW'].includes(printingDataStatus)
            },

            isAnyFinalPrintingData() {
                return R.any(R.propEq('areFinalPrintData', true), this.productFileModels)
            }

        },

        methods: {

            getProductFileModel(fileModel) {
                return R.find(R.propEq('file', fileModel.id), this.productFileModels)
            }

        },

        props: {

            actions: {
                type: Array,
                default: () => [ 'delete', 'hashlink', 'download', 'changeType' ]
            },

            fileModels: {
                type: Array,
                required: true
            },

            hideDetails: {
                type: Boolean,
                default: false,
            },

            productFileModels: {
                type: Array,
                required: true
            },

            productModel: {
                type: Object,
                required: true
            }

        }

    }

</script>
